import script from "./mainCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./mainCourse.vue?vue&type=script&setup=true&lang=js"

import "./mainCourse.vue?vue&type=style&index=0&id=ae0b7e2a&scoped=true&lang=scss"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae0b7e2a"]])

export default __exports__